import React from "react";
import Loader from "./Loader";
import Fade from "../animations/Fade";

function LoaderWithFading(props) {
    const { isVisible, style, className } = props;

    return (
        isVisible && (
            <Fade className={className} style={{ height: "100%", ...style }}>
                <Loader />
            </Fade>
        )
    );
}

LoaderWithFading.defaultProps = {
    isVisible: true,
};

export default LoaderWithFading;
